import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { msalConfig } from './config/authConfig';

import App from './header.jsx';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';


const msalInstance = new PublicClientApplication(msalConfig);


render(
    <MsalProvider instance={msalInstance}>
        <App />
    </MsalProvider>
    , document.getElementById('root-react'));

if (module.hot) {
    module.hot.accept('./screens/Root/index.jsx', () => {
        render(
            <React.Fragment>
                <AppContainer>
                    <App/>
                </AppContainer>
            </React.Fragment>,
            document.getElementById('root-react'),
        );
    });
}
